import { Component } from '@angular/core';

@Component({
  selector: 'app-my-notification',
  templateUrl: './my-notification.component.html',
  styleUrl: './my-notification.component.scss'
})
export class MyNotificationComponent {

}
